import { BehaviorSubject } from 'rxjs';
import { SerializedDrawing } from 'lightweight-charts-drawing';

export type DrawingCommand =
  | { kind: 'add'; snapshot: SerializedDrawing }
  | { kind: 'remove'; snapshot: SerializedDrawing }
  | { kind: 'update'; before: SerializedDrawing; after: SerializedDrawing }
  | { kind: 'clear'; snapshots: SerializedDrawing[] };

/**
 * Pila de comandos undo/redo sobre snapshots serializados.
 * Quien la usa (el controller) es responsable de aplicar/revertir cada comando.
 */
export class DrawingHistory {
  private readonly limit = 100;
  private undoStack: DrawingCommand[] = [];
  private redoStack: DrawingCommand[] = [];

  public readonly canUndo$ = new BehaviorSubject<boolean>(false);
  public readonly canRedo$ = new BehaviorSubject<boolean>(false);

  public push(cmd: DrawingCommand): void {
    this.undoStack.push(cmd);
    if (this.undoStack.length > this.limit) this.undoStack.shift();
    this.redoStack = [];
    this.publish();
  }

  public popUndo(): DrawingCommand | null {
    const cmd = this.undoStack.pop() ?? null;
    if (cmd) this.redoStack.push(cmd);
    this.publish();
    return cmd;
  }

  public popRedo(): DrawingCommand | null {
    const cmd = this.redoStack.pop() ?? null;
    if (cmd) this.undoStack.push(cmd);
    this.publish();
    return cmd;
  }

  public clear(): void {
    this.undoStack = [];
    this.redoStack = [];
    this.publish();
  }

  private publish(): void {
    this.canUndo$.next(this.undoStack.length > 0);
    this.canRedo$.next(this.redoStack.length > 0);
  }
}
